import { useWeb3React } from "@web3-react/core";
import { CHAINS, Chain, ChainId } from "../config/web3/chains";

const useChain = (): Chain => {
  const { chainId } = useWeb3React();
  return CHAINS[(chainId as ChainId) ?? ChainId.BSC_MAINNET];
};

export default useChain;
